import React from 'react';
import { Container } from './Container';
import { VideoGrid } from './VideoGrid';
import { useUIState } from '../shared/contexts/UIStateProvider';
import { SpeakerView } from './SpeakerView';
import { Box } from '@mui/material';
import { useScreenShare } from '@daily-co/daily-react-hooks';
import { CHAT_ASIDE } from './ChatAside';

export function Room({ children }: any) {

	const { showParticipantsBar, setShowAside, isFirstRender, setFirstRender } = useUIState();
	// Grid has no screen tile: derive from live state, the tray's track-started switch can be missed.
	const { screens } = useScreenShare();
	const isSpeakerView = showParticipantsBar || screens.length > 0;

	React.useEffect(() => {
		if (isFirstRender) {
			setFirstRender(false);
			// setShowAside(CHAT_ASIDE);
		}
	}, []);

	return (
		<Container>
			<Box
				sx={{
					flex: `1 1 auto`,
					position: `relative`,
					overflow: `hidden`,
					minHeight: 0,
					height: 1,
					width: 1,
					pb: 1,
				}}
			>
				{children
					? children
					: isSpeakerView
						? <SpeakerView />
						: <VideoGrid />
				}
			</Box>
		</Container>
	);
}
